import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { Tag } from "../../domain/models/tag";
import { MasterlocationRepository } from "../../repositories/master-location.repository";

@Injectable({ providedIn: 'root' })
export class GetTagsUsecase implements UseCase<null, Tag[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(): Observable<Tag[]> {
    return this.masterlocationRepository.getTags();
  }

}